// extracted by css-extract-rspack-plugin
export default {"container":"bDusev8qIp4Vvi2k","message":"EKa536nPCmQlPeYV"};